import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, createVNode, withCtx, Fragment, renderList, createCommentVNode, createBlock, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es95.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es133.js';

const _hoisted_1 = { class: "breadcrumb__inner" };
const _hoisted_2 = { class: "breadcrumb__link-text" };
const _hoisted_3 = {
  key: 1,
  class: "breadcrumb__link"
};
const _hoisted_4 = { class: "breadcrumb__link-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Breadcrumb",
  props: {
    items: {},
    colorMode: { default: "light" }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        class: normalizeClass(["breadcrumb", { "theme-light": _ctx.colorMode === "light" }, { "theme-dark": _ctx.colorMode === "dark" }]),
        "aria-label": "Breadcrumb"
      }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(_sfc_main$1, null, {
            default: withCtx(() => [
              createElementVNode("ol", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (navItem, index) => {
                  return openBlock(), createElementBlock("li", {
                    class: normalizeClass([
                      "breadcrumb__item",
                      {
                        "is-home": index === 0,
                        "is-last": index === props.items.length - 1
                      }
                    ]),
                    key: `${index}-${navItem.text}`
                  }, [
                    navItem.link && navItem.text ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      index < props.items.length - 1 ? (openBlock(), createBlock(_sfc_main$2, {
                        key: 0,
                        uri: navItem.link.uri,
                        class: "breadcrumb__link"
                      }, {
                        default: withCtx(() => [
                          createElementVNode("span", _hoisted_2, toDisplayString(navItem.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["uri"])) : (openBlock(), createElementBlock("div", _hoisted_3, [
                        createElementVNode("span", _hoisted_4, toDisplayString(navItem.text), 1)
                      ]))
                    ], 64)) : createCommentVNode("", true)
                  ], 2);
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
